import { useCallback, useMemo } from 'react';
import { useAvaAIVisibility } from '../../providers/AvaAIContext';
import { PopoutWindow } from '../PopoutWindow/PopoutWindow';
import { AvaAIContent } from './AvaAIContent';
import { AVA_AI_DISPLAY_NAME, AVA_AI_POPOUT_HEIGHT, AVA_AI_POPOUT_WIDTH, AVA_AI_POPOUT_WINDOW_NAME } from './tokens';

const POPOUT_LEFT = 100;
const POPOUT_TOP = 100;

export function AvaAIPopout() {
  const { isEnabled, isOpen, isPopped, close, dockBack, registerPopoutWindow } = useAvaAIVisibility();

  // Stable child element: close is a stable useCallback so this reference won't change
  // between renders unless visibility state itself changes, preventing NewWindow from
  // closing and reopening the popout window during streaming message updates.
  const content = useMemo(() => <AvaAIContent onClose={close} />, [close]);
  const handleOpen = useCallback(
    (openedWindow: Window) => {
      registerPopoutWindow(openedWindow);
    },
    [registerPopoutWindow]
  );
  const handleClose = useCallback(() => {
    registerPopoutWindow(null);
    dockBack();
  }, [dockBack, registerPopoutWindow]);

  if (!isEnabled || !isOpen || !isPopped) {
    return null;
  }

  return (
    <PopoutWindow
      name={AVA_AI_POPOUT_WINDOW_NAME}
      title={AVA_AI_DISPLAY_NAME}
      width={AVA_AI_POPOUT_WIDTH}
      height={AVA_AI_POPOUT_HEIGHT}
      left={POPOUT_LEFT}
      top={POPOUT_TOP}
      onOpen={handleOpen}
      onClose={handleClose}
    >
      {content}
    </PopoutWindow>
  );
}
